// extracted by mini-css-extract-plugin
export default {"btnIcon":"icons-button_btnIcon__rbvuT"};